<template>
    <div id="app">
        <meta name="referrer" content="no-referrer">
        <router-view/>
    </div>
</template>

<script>

    export default {
        name: 'app',
    }
</script>

<style>
    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        height: 100%;
        color: #2c3e50;
    }

    body {
        margin: 0;
        padding: 0;
        height: 100vh;
        min-height: 1000px;
    }
</style>
